module.exports = __webpack_public_path__ + "media/images/logos/RMIT-University-ba7d97c2ecf517b61cc452708506ec45.svg";